<template>
    <v-sheet class="chart-container" :style="`position: relative; height:${height}; width:${width}; max-width:${maxWidth}`">
        <canvas ref="chart"></canvas>
    </v-sheet>
</template>
<script>
import Chart from "chart.js/auto";
import ChartDataLabels from 'chartjs-plugin-datalabels';
export default {
    props:{
        chartType:String,
        chartData:Object,
        chartOptions:Object,
        scales:Object,
        width: String,
        height: String,
        maxWidth: String,
        label: String,
        ratio: Number,
        indexAxis: String,
        legendPos: String,
        showLabel: Boolean
    },
    data(){
        return {
            chart:undefined
        }
    },
    methods:{
        chartConstructor(chartType, chartData, chartOptions) {
            const chartElement = this.$refs.chart;
            this.chart = new Chart(chartElement, {
                type: chartType,
                data: chartData,
                plugins:[
                        ChartDataLabels
                        ],
                options: {
                    indexAxis: !!this.indexAxis ? this.indexAxis : "x",
                    responsive: true,
                    maintainAspectRatio: !this.height,
                    aspectRatio: this.ratio,
                    plugins: {
                        datalabels: {
                            anchor: 'end',
                            color: 'black',
                            display: !!this.showLabel ? this.showLabel : false
                        },
                        title: {
                            display: !!this.label,
                            text: this.label,
                            position: "bottom",
                            font: {size: 16},
                        },
                        legend: {
                            position: this.legendPos || "left",
                        },
                    },
                    scales: this.scales,
                    onClick: (event, elements) => {
                        if (elements && elements.length > 0) {
                            const firstElement = elements[0];
                            const datasetIndex = firstElement.datasetIndex;
                            const index = firstElement.index;
                            
                            this.$emit('click:element', {
                                index: index,
                                datasetIndex: datasetIndex,
                                label: this.chartData && this.chartData.labels ? this.chartData.labels[index] : null,
                                value: this.chartData && this.chartData.datasets && this.chartData.datasets[datasetIndex] ? this.chartData.datasets[datasetIndex].data[index] : null
                            });
                        }
                    },
                    ...chartOptions
                },
            });
        },
        update(){
            if (this.chart) {
                this.chart.update();
            }
        }
    },
    watch: {
        chartData: {
            handler() {
                this.$nextTick(() => {
                    this.update();
                });
            }
        }
    },
    mounted(){
        let {chartType,chartData,chartOptions} = this;
        this.chartConstructor(chartType, chartData, chartOptions);
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.destroy();
        }
    }
}
</script>